export interface GanttSegment {
	from: Date;
	to: Date;
	value: string;
	color: string;
	isOverlap?: boolean;
	valueId?: string;
	underlyingSegments?: GanttSegment[];
	additionalData?: any;
	additionalDataType?: string;
	unit?: string;
}

export interface GanttRow {
	label: string;
	typeId?: string;
	segments: GanttSegment[];
	overlaps?: GanttSegment[]; // <-- ADD THIS LINE
}

export interface BarTextStyle {
	fontFamily?: string;
	fontSize?: string;
	color?: string;
	fontWeight?: string | number;
}

export interface GanttClickEvent {
	segment?: GanttSegment;
	row?: GanttRow;
	parameterValueType?: ParameterValueType;
}

export enum ParameterValueType {
	TENANT = 'tenant',
	SHARE = 'share',
	SELECTION = 'selection',
	TARIFF = 'tariff',
	ROLE = 'role',
	PAYMENT = 'payment',
	SETTING = 'setting',
}
